<template>
  <AiActivationDialog
    v-if="prompt"
    :visible="visible"
    :prompt="prompt"
    :dismiss_label="$t('ai.activation.not_now')"
    @close="snoozePrompt"
    @activated="visible = false"
  />
</template>

<script setup>
// Asks an owner after login to switch the conversation agent on for their client, while Ziggu offers it and no owner
// decided yet. Employee.vue shows it to owners outside a login as session only, and the API refuses the akkoord to
// anyone else. Niet nu hides it in this browser for a month.
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { mapActions } from '@/store/lib/vue3helpers.js';
import { LOCALSTORAGE_OPTIONS } from '@/store/lib/local_storage.js';
import { useToasts } from '@/app/util/toasts.js';
import useUpsellSnooze from '@/composables/useUpsellSnooze';
import AiActivationDialog from '@/app/_employees/components/ai/AiActivationDialog.vue';

const { t } = useI18n();
const { toast_info } = useToasts();
const { FETCH_AI_ACTIVATION_PROMPT } = mapActions(['FETCH_AI_ACTIVATION_PROMPT']);
const { is_snoozed, snooze } = useUpsellSnooze(LOCALSTORAGE_OPTIONS.AI_ACTIVATION_PROMPT);

const prompt = ref(null);
const visible = ref(false);

onMounted(async () => {
  if (is_snoozed.value) return;
  try {
    prompt.value = await FETCH_AI_ACTIVATION_PROMPT();
    visible.value = prompt.value.attributes.offered && !prompt.value.attributes.decided;
  } catch {
    // the prompt waits for the next login; nothing the owner asked for failed
  }
});

// closing the prompt counts as Niet nu
function snoozePrompt() {
  visible.value = false;
  snooze();
  toast_info(
    t('ai.activation.snoozed', {
      features: t('client.labels.tab_features'),
      conversations: t('client.labels.conversations'),
    }),
  );
}
</script>
